import MyDealerListTable from './myDealerListTable.container';

export default MyDealerListTable